import { useDispatch, useSelector } from 'react-redux';
import { IState, actions } from '../../Store/reducer';
import { episodes } from '../../Services/episodes';
import "./scene.scss";

interface ISceneProps {
    display: boolean;
}

export default function Scene(props: ISceneProps) {

    const { episodeNumber, sceneNumber } = useSelector((state: IState) => state.master);

    const dispatch = useDispatch();

    function changeScene(increment: number) {
        if (episodes[episodeNumber].scene[sceneNumber + increment]) {
            dispatch({
                type: actions.master.SET_SCENE_NUMBER,
                payload: { master: { sceneNumber: sceneNumber + increment } }
            });
        }
    }

    return (
        <>
            {episodes[episodeNumber] && props.display &&
                <div className="scene-controls">
                    <svg className={!episodes[episodeNumber].scene[sceneNumber - 1] ? "left disabled" : "left"} onClick={() => changeScene(-1)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.49 115"><g><path fill="#ec6729" d="m7.88,71.12l70.84,41.59c10.51,6.4,23.77-1.37,23.77-13.71V15.81c0-12.34-13.25-19.65-23.77-13.71L7.88,43.69c-10.51,6.4-10.51,21.03,0,27.42h0Z" /></g></svg>

                    <div className="label">
                        <img src="/image/episodes/background-controls.png" alt="fond" />
                        <div className="label-text">Épisode {episodeNumber} - Scène {sceneNumber}</div>
                    </div>

                    <svg className={!episodes[episodeNumber].scene[sceneNumber + 1] ? "right disabled" : "right"} onClick={() => changeScene(+1)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.49 115"><g><path fill="#ec6729" d="m94.61,43.88L23.77,2.29C13.26-4.11,0,3.66,0,16v83.18c0,12.34,13.25,19.65,23.77,13.71l70.84-41.59c10.51-6.4,10.51-21.03,0-27.42h0Z" /></g></svg>
                </div>
            }
        </>
    );
}